import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Login from "./components/Login/Login";
import MainDashboard from "./components/Dashboard/MainDashboard";
import NotFound from "./pages/NotFound";
import { Toaster } from "sonner";
import { APPS_CONFIG } from "./config/appsConfig";
import { isProd } from "./apis/templateApi/apiConfig";

// Loaded on demand, so /login and /dashboard don't wait for every app's code
const AppDashboard = lazy(() => import("./components/Dashboard/AppDashboard"));
const PrakashakLayout = lazy(() => import("./pages/PrakashakStaticReport/PrakashakLayout"));
const Dashboard = lazy(() => import("./pages/PrakashakStaticReport/Dashboard/Dashboard"));
const Schoolwise = lazy(() => import("./pages/PrakashakStaticReport/Schoolwise/Schoolwise"));
const Retention = lazy(() => import("./pages/PrakashakStaticReport/RetentionMetrics/RetentionMetrics"));
const AnganwadiWise = lazy(() => import("./pages/PrakashakStaticReport/Anganwadiwise/Anganwadiwise"));
const WhatsappChatbot = lazy(() => import("./pages/PrakashakStaticReport/WhatsappChatbot/WhatsappChatbot"));
const RemoteInstruction = lazy(() => import("./pages/PrakashakStaticReport/RemoteInstructions/RemoteInstructions"));
const DashboardMonthly = lazy(() => import("./pages/PrakashakStaticReport/DashboardMonthly/DashboardMonthly"));
const BlockWise = lazy(() => import("./pages/PrakashakStaticReport/Blockwise/Blockwise"));
const OverallWebapp = lazy(() => import("./pages/PrakashakStaticReport/OverallWebapp/OverallWebapp"));
const ThreadEngagement = lazy(() => import("./pages/PrakashakStaticReport/Thread Engagement/ThreadEngagement"));
const DistrictBlockPage = lazy(() => import("./pages/PrakashakStaticReport/GroupReport/DistrictBlockPage"));
const WebappOnboarding = lazy(() => import("./pages/PrakashakStaticReport/WebappOnboarding/WebappOnboarding"));

function App() {
  const { user, loading } = useAuth();

  // useEffect(() => {
  //   if (!isProd) return;

  //   const handleContextMenu = (e) => e.preventDefault();

  //   const handleKeyDown = (e) => {
  //     const key = e.key.toLowerCase();

  //     if (e.keyCode === 123) return e.preventDefault();

  //     if (
  //       (e.ctrlKey || e.metaKey) &&
  //       e.shiftKey &&
  //       ["i", "j", "c", "k"].includes(key)
  //     )
  //       return e.preventDefault();

  //     if ((e.ctrlKey || e.metaKey) && key === "u") return e.preventDefault();

  //     if ((e.ctrlKey || e.metaKey) && key === "s") return e.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      <Toaster richColors position="top-right" />
      <Router>
        <Suspense fallback={<div className="loading">Loading...</div>}>
        <Routes>
          <Route
            path="/login"
            element={!user ? <Login /> : <Navigate to="/dashboard" />}
          />

          <Route
            path="/dashboard"
            element={user ? <MainDashboard /> : <Navigate to="/login" />}
          />

          <Route path="/prakashak" element={<PrakashakLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="schoolwiseNew" element={<Schoolwise />} />
            <Route path="blockwise" element={<BlockWise />} />
            <Route path="dashboard_monthly" element={<DashboardMonthly />} />
            <Route path="remote_instructions" element={<RemoteInstruction />} />
            <Route path="whatsapp_chatbot" element={<WhatsappChatbot />} />
            <Route path="anganwadiwise" element={<AnganwadiWise />} />
            <Route path="retention_metrics" element={<Retention />} />
            <Route path="overall_webapp" element={<OverallWebapp />} />
            <Route path="webapp_onboarding" element={<WebappOnboarding />} />
            <Route path="thread_engagement" element={<ThreadEngagement />} />
            <Route path="district_block" element={<DistrictBlockPage />} />
          </Route>

          <Route
            path="/"
            element={<Navigate to={user ? "/dashboard" : "/login"} />}
          />

          {Object.entries(APPS_CONFIG).map(([appKey, config]) => (
            <Route
              key={appKey}
              path={`${config.route}/*`}
              element={user ? <AppDashboard /> : <Navigate to="/login" />}
            />
          ))}

          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
